
import { VSlideItem } from "vuetify/lib";

export default VSlideItem.extend({});
